// extracted by mini-css-extract-plugin
export default {"starterScreen":"mh","starterImage":"nh","already":"oh","starterImageMobile":"ph","controlX":"qh","starterTextContain":"rh","starterHeader":"sh","starterBtn":"th","starterSecondaryBtn":"uh","starterBanner":"vh","mobileBtnContainer":"wh"};
    if(module.hot) {
      // 1713969922371
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  